import template from './RegisterUserModule.html';
import RegisterCustomerUserComponent from '../../components/RegisterCustomerUser/RegisterCustomerUserComponent';

export default {
  template,

  components: {
    RegisterCustomerUserComponent,
  },

  methods: {
    successHandler() {
      window.location = '/min-side';
    },
  },
};
